<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
  >
    <g clip-path="url(#clip0_3694_6883)">
      <path
        d="M33.469 9.39356C33.2951 8.69894 32.941 8.06249 32.4425 7.54851C31.9439 7.03453 31.3185 6.66122 30.6295 6.46629C28.1121 5.85156 18.0422 5.85156 18.0422 5.85156C18.0422 5.85156 7.97242 5.85156 5.45497 6.52484C4.76596 6.71977 4.14059 7.09308 3.64203 7.60706C3.14347 8.12104 2.78938 8.75748 2.61552 9.45211C2.15478 12.007 1.92942 14.5987 1.94224 17.1947C1.92582 19.8103 2.1512 22.4218 2.61552 24.9959C2.80719 25.669 3.16922 26.2812 3.66662 26.7735C4.16402 27.2658 4.77997 27.6214 5.45497 27.8061C7.97242 28.4794 18.0422 28.4794 18.0422 28.4794C18.0422 28.4794 28.1121 28.4794 30.6295 27.8061C31.3185 27.6112 31.9439 27.2379 32.4425 26.7239C32.941 26.2099 33.2951 25.5735 33.469 24.8788C33.9261 22.3432 34.1515 19.7712 34.1422 17.1947C34.1587 14.5792 33.9333 11.9677 33.469 9.39356V9.39356Z"
        stroke="currentColor"
        stroke-width="2.92727"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.75 21.9862L23.1659 17.2002L14.75 12.4141V21.9862Z"
        stroke="currentColor"
        stroke-width="2.92727"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3694_6883">
        <rect
          width="35.1273"
          height="35.1273"
          fill="currentColor"
          transform="translate(0.480469)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({ className: String });
</script>
